import React, { useEffect } from "react";
import { CallAPI } from "services/API";
import TableWithContainer from "utils/Table/TableWithContainer";

export default function CompCollVehiclesTypePolicies(props) {
    const integer = new Intl.NumberFormat('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
    const percent = new Intl.NumberFormat('en-US', {
        style: 'percent',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    });
    const currency = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    });
    const headers = [["Coverage Type", "Vehicles Bound", "%", "Avg Prem"]];

    const [data, setData] = React.useState([
        ["LIABILITY ONLY", integer.format(0), percent.format(0), currency.format(0)],
        ["COLL/COMP", integer.format(0), percent.format(0), currency.format(0)],
        ["COMP ONLY", integer.format(0), percent.format(0), currency.format(0)],
        ["TOTAL", integer.format(0), percent.format(0), currency.format(0)]
    ]);
    const [loading, setLoading] = React.useState(false);

    const GetData = async () => {
        const response = await CallAPI("POST", "/Home/GetVehiclesByCoverageTypePolicies", {
            startDate: props.startDate,
            endDate: props.endDate,
            states: props.states,
            city: props.city
        });

        if (response) {
            const formattedResponse = [
                [
                    "LIABILITY ONLY",
                    integer.format(response.liabilityOnlyVehiclesBound),
                    percent.format(response.liabilityOnlyPercentage / 100),
                    currency.format(response.liabilityOnlyAvgPremium)
                ], [
                    "COLL/COMP",
                    integer.format(response.collCompVehiclesBound),
                    percent.format(response.collCompPercentage / 100),
                    currency.format(response.collCompAvgPremium)
                ], [
                    "COMP ONLY",
                    integer.format(response.compOnlyVehiclesBound),
                    percent.format(response.compOnlyPercentage / 100),
                    currency.format(response.compOnlyAvgPremium)
                ], [
                    "TOTAL",
                    integer.format(response.totalVehiclesBound),
                    percent.format(response.totalPercentage / 100),
                    currency.format(response.totalAvgPremium)
                ]
            ];

            if (props.comments?.length > 0) {
                headers[0].push('');
                formattedResponse.map(x => {
                    let comment = props.comments.find(y => y.row.toLowerCase() == x[0].toLowerCase());
                    x.push(comment ? comment.message : '');
                });
            }

            setData(formattedResponse);
        }

        setLoading(false);
    };

    useEffect(() => {
        if (props.call === "true" || props.call === null) {
            GetData();
            setLoading(true);
        }
    }, [props.call]);
    
    return (
        <div>
            <TableWithContainer
                title="VEHICLES BY COVERAGE TYPE - POLICIES"
                loading={loading}
                fixedColumns={1}
                headers={headers}
                rows={data.filter(x => x[0] !== 'TOTAL')}
                footers={data.filter(x => x[0] === 'TOTAL')}
                exportName="VehiclesByCoverageTypePolicies"
            />
        </div>
    );
}
